import React from "react";
import { Switch, Route } from "react-router-dom";
import Category from "./Category/";
import Schedule from "./Schedule/";
import Question from "./Question/";
import Score from "./Score/";
import Analytics from 'react-router-ga';
import Report from "./Report/";
import Pantau from "./Pantau/";
import KartuUjian from "./KartuUjian/";
import UploadRapor from "./UploadRapor";

class Materi extends React.Component {
	render() {
		return (
			<div className="animated fadeIn">
				<div className="row">
					<Analytics id="UA-123076872-5" debug>
					<Switch>
						<Route
							path={`${this.props.match.url}/category`}
							component={Category}
						/>
						<Route
							path={`${this.props.match.url}/question`}
							component={Question}
						/>
						<Route
							path={`${this.props.match.url}/schedule`}
							component={Schedule}
						/>
                        <Route
                            path={`${this.props.match.url}/report`}
                            component={Report}
                        />
                        <Route
                            path={`${this.props.match.url}/pantau`}
                            component={Pantau}
                        />
						<Route
							path={`${this.props.match.url}/score`}
							component={Score}
						/>
						<Route
							path={`${this.props.match.url}/kartu-ujian`}
							component={KartuUjian}
						/>
						<Route
							path={`${this.props.match.url}/upload-rapor`}
							component={UploadRapor}
						/>
					</Switch>
					</Analytics>
				</div>
			</div>
		);
	}
}

export default Materi;



// WEBPACK FOOTER //
// ./src/views/Exam/index.js